import { ref, readonly } from 'vue';
import { defineStore } from 'pinia';
import { useRouter } from 'vue-router/composables';

export const useNsioHistoryStore = defineStore('nsio/history', () => {
    const initial = ref(true);
    const prev_info = ref({ exist: false });
    let called_reproduce = false;
    const _reproduce_mode = ref(false);
    let called_browser_history = false;
    const _browser_history_mode = ref(false);
    let called_search = false;
    const _search_mode = ref(false);
    let redirected = false;

    function reset() {
        initial.value = true;
        prev_info.value.exist = false;
    }

    const router = useRouter();
    router.afterEach((to, from) => {
        if (initial.value) {
            // 一番最初のページ読み込み時は記録しない
            initial.value = false;
            // リダイレクトで遷移した場合
            if (to.query.redirect) {
                redirected = true;
            }
        } else {
            prev_info.value.exist = true;
            if (called_reproduce) {
                _reproduce_mode.value = true;
                if (!redirected) {
                    called_reproduce = false;
                }
            } else {
                _reproduce_mode.value = false;
            }
            if (called_browser_history) {
                _browser_history_mode.value = true;
                called_browser_history = false;
                prev_info.value.exist = false;
            } else {
                _browser_history_mode.value = false;
            }
            if (called_search) {
                _search_mode.value = true;
                if (!redirected) {
                    called_search = false;
                }
            } else {
                _search_mode.value = false;
            }
        }
    });

    function goPrevWithReproduce() {
        router.back();
        called_reproduce = true;
    }

    function goPrevWithReload() {
        router.back();
        called_search = true;
    }

    window.addEventListener('popstate', event => {
        if (!called_reproduce && !called_search) {
            called_browser_history = true;
        }
        // リダイレクトで遷移した場合の処理
        if (redirected) {
            if (called_browser_history) {
                _browser_history_mode.value = true;
                called_browser_history = false;
                prev_info.value.exist = false;
            }
            called_reproduce = false;
            called_search = false;
        }
    });

    const prev = readonly(prev_info);
    const reproduce_mode = readonly(_reproduce_mode);
    const browser_history_mode = readonly(_browser_history_mode);
    const search_mode = readonly(_search_mode);

    return {
        prev,
        reproduce_mode,
        browser_history_mode,
        search_mode,
        reset,
        goPrevWithReproduce,
        goPrevWithReload,
    };
});
